import { createGlobalStyle } from 'styled-components';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.js';
import 'open-iconic/font/css/open-iconic-bootstrap.css';
import './balloons.css';

const Global = createGlobalStyle`

  * {
    margin: 0;
    padding: 0;
    outline: 0;
    box-sizing: border-box;
  }

  *:focus {
    outline: 0;
  }

  html, body, #root {
    height: 100%;
    font-family: 'Roboto', sans-serif;
    font-size: .94rem;
  }

  *body {
    @import url('https://fonts.googleapis.com/css?family=Roboto:400,400i,500,500i,700,700i&display=swap');
    font-family: 'Roboto';
    --webkit-font-smoothing: antialiased;
  }

  input, button {
    font: .95rem 'Roboto', sans-serif;
  }

  a {
    text-decoration: none;
  }

  ul {
    list-style: none;
  }

  button {
    cursor: pointer;
  }

  main {
    flex-grow: 1;
  }

  header, main, footer {
    flex-shrink: 0;
  }

  h1, h2, h3, h4, h5, h6,
  .h1, .h2, .h3, .h4, .h5, .h6 {
    margin-bottom: 0.5rem;
    font-family: inherit;
    font-weight: 500;
    line-height: 1.2;
    color: inherit;
  }

  .page-container {
    margin-top: 56px;

    @media only screen and (max-width: 768px) {
      margin-top: 56px;
      margin-left: 0px;

       &.representant-page {
        margin-top: 112px;
       }
    }
  }

  .big-icon {
    color: #354153;
    font-size: 11em;
  }

  .dark-bg {
    background-color: #354153;
  }

  .btn-link {
    font-size: 0.95rem !important;
  }

  @media only screen and (min-width: 1700px) {
    .container-fluid.big-resolutions {
      width: 80%;
    }
  }

  .tab {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }

  .fc-col-header-cell-cushion {
    text-decoration: none;
    color: black;
    text-transform: uppercase;
  }

  .fc-daygrid-day-number {
    text-decoration: none;
    color: black;
  }

  .fc-daygrid-event-dot {
    display: none;
  }

  .loading-container {
    height: calc(100vh - 56px);
  }

  .modal-backdrop,
  .modal {
    z-index: 3000000000 !important;
  }

  .new-menu-header {
    .page-container {
      margin-left: 0;
    }

    .filter-bar,
    .filter-button {
      left: 0;
    }

    &.hasTopBanner {
      .bg-open {
        &.menu-open {
          height: calc(100vh - 56px - 80px);
        }
      }
    }

    &.hasAmbassadorBanner {
      .bg-open {
        &.menu-open {
          height: calc(100vh - 56px - 52px);

          @media only screen and (max-width: 768px) {
            height: calc(100vh - 56px - 72px);
          }
        }
      }
    }
  }

  .pac-container {
    z-index: 9999999999 !important;
  }
  
  body.hide-tallos #megasac-chat,
  body.hide-tallos #megasac-button,
  body.hide-tallos #megasac-info,
  body.hide-tallos #tallos-footer {
    display: none !important;
    opacity: 0 !important;
    pointer-events: none !important;
  }

  /* #tawkchat-container,
  .tawk-min-container,
  iframe[src*="tawk"] {
    display: none !important;
    visibility: hidden !important;
    opacity: 0 !important;
    pointer-events: none !important;
  } */

  .widget-visible{
    display: none !important;
  }

  .audio-loading-bars {
    display: flex;
    align-items: flex-end;
    gap: 3px;
    height: 20px;

    span {
      width: 3px;
      height: 6px;
      background: #6c757d;
      border-radius: 2px;
      animation: loading 1s infinite ease-in-out;
    }

    span:nth-child(1) {
      animation-delay: 0s;
    }
    span:nth-child(2) {
      animation-delay: 0.15s;
    }
    span:nth-child(3) {
      animation-delay: 0.3s;
    }

    @keyframes loading {
      0% {
        height: 6px;
        opacity: 0.4;
      }
      50% {
        height: 18px;
        opacity: 1;
      }
      100% {
        height: 6px;
        opacity: 0.4;
      }
    }
  }

  .btn-ia {
    border: 1px solid transparent;
    background: linear-gradient(90deg, #007bff, #009f79) padding-box,
      linear-gradient(90deg, #007bff, #009f79) border-box;
  }

  .btn-outline-ia {
    border: 1px solid transparent;
    background: linear-gradient(#fff, #fff) padding-box,
      linear-gradient(90deg, #007bff, #009f79) border-box;
      
  }

  .span-outline-ia {
    background: linear-gradient(90deg, #007bff 0%, #009f79 100%);
    background-clip: text;
    color: transparent;
  }

  .btn-outline-ia-opacity {
    background: linear-gradient(90deg, rgba(0, 123, 255, 0.10) 0%, rgba(0, 159, 121, 0.10) 100%);
     border: 1px solid #007BFF;
  }
`;

export default Global;
